module.exports = __webpack_public_path__ + "media/images/icon_twitter-8f0f0ccfed1e918ab74723ed36d7fdcf.svg";